<template>
  <div>
    <el-dialog
      title="竟代管理"
      width="700px"
      top="5vh"
      :visible.sync="visible"
      class="jdgl-dialog"
      @close="closeDialog"
    >
      <div style="width:100%" id="dialog-modal">
        <el-button
          size="mini"
          type="primary"
          @click="addJdFn()"
          class="addJd"
          v-if="pageFuncNames.includes('add_compete_plat_username')"
          v-matomo="{behaviorCategory: `竞代数据管理(${platName})`,  name: '竟代管理(添加竞代)' }"
        >添加竞代</el-button>

        <div>
          <el-table :data="newData" v-loading="jdglLoading" border style="width: 100%" height="400">
            <el-table-column prop="plat_username" label="代理名称" width="180">
              <template slot-scope="scope">
                <div v-if="showUserName!==scope.$index">
                  <span>{{scope.row.plat_username}}</span>
                </div>
                <div v-else>
                  <el-input
                    clearable
                    v-model.trim="scope.row.plat_username"
                    @change="changeReg(scope.row.plat_username)"
                    placeholder="请输入1-10个字"
                    @fouce="handleFouce(scope.$index, scope.row)"
                  ></el-input>
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="start_date" label="代理负责日期" width="300">
              <template slot-scope="scope">
                <div v-if="showDate!==scope.$index">
                  <span>{{scope.row.start_date}}</span> 至
                  <span>{{scope.row.end_date}}</span>
                </div>
                <div v-else>
                  <el-date-picker
                    v-model="modelTime"
                    type="daterange"
                    align="left"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="changeTime"
                    :picker-options="pickerOptions"
                    clearable
                    style="width:260px;padding-right:0px"
                  ></el-date-picker>
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="address" label="操作">
              <template slot-scope="scope">
                <span v-if="showBtn!==scope.$index">
                  <i
                    class="el-icon-edit-outline"
                    v-matomo="{behaviorCategory: `竞代数据管理(${platName})`,  name: '竟代管理(编辑竞代)' }"
                    @click="handleEdit(scope.$index, scope.row,'编辑')"
                    v-if="pageFuncNames.includes('edit_compete_plat_username')"
                  ></i>
                  <i
                    class="el-icon-delete"
                    v-matomo="{behaviorCategory: `竞代数据管理(${platName})`,  name: '竟代管理(删除竞代)' }"
                    @click="handleDelet(scope.$index, scope.row,'删除')"
                    v-if="pageFuncNames.includes('delete_compete_plat_username')"
                  ></i>
                </span>
                <span v-else>
                  <span v-if="saveBtn==true">
                    <i
                      class="el-icon-circle-check"
                      @click="handleAddSave(scope.$index, scope.row,'新增保存')"
                    ></i>
                    <!-- <i
                      class="el-icon-circle-close classred"
                      @click="handleAddClose(scope.$index, scope.row,'新增关闭')"
                    ></i> -->
                  </span>
                  <span v-else>
                    <i
                      class="el-icon-circle-check"
                      @click="handleSave(scope.$index, scope.row,'保存')"
                    ></i>
                    <!-- <i
                      class="el-icon-circle-close classred"
                      @click="handleSaveClose(scope.$index, scope.row,'关闭')"
                    ></i> -->
                  </span>
                </span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="友情提示" :visible.sync="deleteVisible" width="500px">
      <span>是否确认删除当前竞代？</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="deleteSubmit">删 除</el-button>
        <el-button @click="deleteClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api/competeManage.js";
export default {
  props: {
    pageFuncNames: {
      type: Array,
      default: () => {
        return [];
      }
    },
    platName: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      deleteVisible: false, // 删除确认弹窗
      jdglLoading: false, //弹窗loading
      showBtn: "", // 是否展示保存。 true保存编辑和删除
      showUserName: "", //是否展示代理名称
      showDate: "", //是否展示时间
      saveBtn: false, // 是否展示新增保存
      modelTime: [], //展示的时间
      visible: false,
      newData: [],
      nowPlatId: "", //渠道id
      nowIndex: "", //当前条的index
      nowRow: "", //当前条信息
        pickerOptions: {
            firstDayOfWeek: 1,
        },
    };
  },
  watch: {},
  mounted() {},
  methods: {
    //校验input
    changeReg(val) {
      console.log(val);
      let myreg = /[[\/\\*:?"< >|\]\s]/;
      console.log(myreg.test(val));
      if (myreg.test(val)) {
        return false;
      }
    },
    //获取竞代列表
    getData(id) {
      this.jdglLoading = true;
      API.getCompeteList({
        plat_id: id
      }).then(
        res => {
          this.jdglLoading = false;
          let resData = res.data.list;
          this.newData = resData || [];
        },
        err => {
          this.jdglLoading = false;
          this.$message.error(err.info || "竞代数据列表请求失败！");
        }
      );
    },

    //展示弹窗
    showDialog(data) {
      this.nowPlatId = data.platId;
      this.getData(data.platId);
      this.visible = true;
    },

    // 关闭弹窗
    closeDialog() {
      this.showBtn = "";
      this.showUserName = "";
      this.showDate = "";
      this.modelTime = [];
      this.saveBtn = false;
      this.newData = [];
      this.visible = false;
      this.$emit("upDataList", {plat_id:this.nowPlatId},"刷新日历");
    },

    // 竞代管理-点击编辑按钮
    handleEdit(index, row, title) {
      this.nowRow = JSON.stringify(row);

      console.log(this.nowRow);
      // 校验是否有添加
      if (!this.handleCheckItem()) {
        return;
      }
      this.showUserName = index;
      this.showBtn = index;
      this.showDate = index;
      this.modelTime = [row.start_date, row.end_date];
      this.editCompete(index, row);
    },

    //竞代管理-编辑请求参数
    editCompete(index, row) {
      let options = {
        plat_username_id: row.plat_username_id,
        plat_username: row.plat_username,
        start_date: row.start_date,
        end_date: row.end_date
      };
    },

    // 关闭删除二次确认
    deleteClose() {
      this.deleteVisible = false;
    },
    // 确认删除提交
    deleteSubmit() {
      this.deletApi(this.nowRow);
    },
    deletApi(row) {
      API.delCompete({ plat_username_id: row.plat_username_id }).then(
        res => {
          console.log("res", res);
          this.$message({
            message: "竞代删除成功！",
            type: "success"
          });
          this.deleteVisible = false;
          this.getData(this.nowPlatId);
        },
        err => {
          this.$message.error(err.info || "竞代删除失败！");
        }
      );
    },

    //竞代管理-删除
    handleDelet(index, row, title) {
      if (!this.handleCheckItem()) {
        return;
      }
      this.nowRow = row;
      this.deleteVisible = true;
    },

    // blue代理名称
    handleBlur(index, row) {
      if (row.plat_username.length > 10) {
        this.$message("代理名称不能大于10位");
        return false;
      }
    },

    // 校验是否能保存提交
    isCheck(index, row, title) {
      if (row.plat_username == "") {
        this.$message("代理名称不能为空");
        return false;
      } else {
        if (this.handleBlur(index, row) == false) {
          return false;
        }
      }

      if (this.modelTime == null) {
        this.$message("代理负责日期不能为空哦！");
        return false;
      } else {
        if (this.modelTime && this.modelTime.length == 0) {
          this.$message("代理负责日期不能为空");
          return false;
        }
      }
    },

    // 关闭新增内容
    handleAddClose(index, row, title) {
      this.newData.shift();
      this.showBtn = "";
      this.saveBtn = "";
      this.showUserName = "";
      this.showDate = "";

      console.log(this.newData);
    },
    //添加竞代---提交接口
    handleAddSave(index, row, title) {
      if (this.isCheck(index, row, title) == false) {
        return;
      }
      if (this.changeReg(row.plat_username) == false) {
        this.$message.error(
          '代理名称不能包含空格及特殊字符：\\ / : * ? " < > |'
        );
        return;
      }
      let options = {
        plat_id: this.nowPlatId,
        plat_username: row.plat_username,
        start_date: this.modelTime[0],
        end_date: this.modelTime[1]
      };
      API.addCompete(options).then(
        res => {
          row.start_date = this.modelTime[0];
          row.end_date = this.modelTime[1];
          this.showBtn = "";
          this.showUserName = "";
          this.showDate = "";
          this.saveBtn = false;
          this.modelTime = [];
          this.$message({
            message: "竞代添加成功！",
            type: "success"
          });
          this.getData(this.nowPlatId);
        },
        err => {
          this.$message({
            message: err.info || "竞代数据添加失败！",
            type: "error"
          });
       
        }
      );
    },
    //关闭编辑当前行
    handleSaveClose(index, row, title) {
      let baseRow = JSON.parse(this.nowRow);
      this.$set(this.newData, index, {
        plat_username: baseRow.plat_username,
        start_date: baseRow.start_date,
        end_date: baseRow.end_date
      });
      this.showBtn = "";
      this.showUserName = "";
      this.showDate = "";
    },

    //  竞代管理-保存 点击绿图标保存
    handleSave(index, row, title) {
      if (this.isCheck(index, row, title) == false) {
        return;
      }
      if (this.changeReg(row.plat_username) == false) {
        this.$message.error(
          '代理名称不能包含空格及特殊字符：\\ / : * ? " < > |'
        );
        return;
      }
      let options = {
        plat_id: this.nowPlatId,
        plat_username_id: row.plat_username_id,
        plat_username: row.plat_username,
        start_date: this.modelTime[0],
        end_date: this.modelTime[1]
      };
      API.editCompete(options).then(
        res => {
          console.log("res", res);
          this.$message({
            message: "竞代保存成功！",
            type: "success"
          });
          this.getData(this.nowPlatId);
          this.showBtn = "";
          this.showUserName = "";
          this.showDate = "";
        },
        err => {
          this.$message.error(err.info || "竞代保存失败！");
        }
      );
    },

    // 点击代理名称 变输入框
    handleUserName(index, row) {
      this.nowIndex = index;
      if (!this.handleCheckItem()) {
        return;
      }
      this.showUserName = index;
      this.showBtn = index;
      this.modelTime = [row.start_date, row.end_date];
      if (this.showDate != index) {
        this.showDate = !this.showDate;
      }
    },
    // 点击时间编辑时间
    handleTime(index, row) {
      this.nowIndex = index;
      if (!this.handleCheckItem()) {
        return;
      }
      this.showDate = index;
      this.showBtn = index;
      if (this.showUserName != index) {
        this.showUserName = false;
      }
      this.modelTime = [row.start_date, row.end_date];
      console.log("shijian==", this.modelTime);
    },

    // 校验有添加竞代情况不能触发
    handleCheckItem() {
      if (this.showBtn !== "") {
        this.$message("您有正在编辑的内容");
        return false;
      } else {
        return true;
      }
    },
    // 添加竞代按钮
    addJdFn() {
      console.log("====", this.showBtn);
      if (!this.handleCheckItem()) {
        return;
      }

      // 清空 其他条时间清空的情况
      if (this.modelTime && this.modelTime.length != 0) {
        this.modelTime = [];
      }
      // if (this.saveBtn ) {
      //   this.$message("您有未保存的竞代信息！");
      //   return
      // }

      // 追加一条新数据在数据最前面
      this.newData.unshift({
        plat_username_id: "",
        plat_username: "",
        start_date: "",
        end_date: ""
      });
      // this.modelTime[this.newData[0].start_date,this.newData[1].end_date]
      console.log(this.newData);

      this.showUserName = 0;
      this.showDate = 0;
      this.showBtn = 0;
      this.saveBtn = true;
    },

    handleFouce() {},

    //修改时间
    changeTime(e) {
      console.log(e);
    }
  }
};
</script>

<style lang="scss">
.jdgl-dialog {
  .el-icon-edit-outline {
    color: #409eff;
    font-size: 20px;
  }
  .el-icon-delete {
    color: red;
    font-size: 20px;
    display: inline-block;
    margin-left: 4px;
  }
  .el-icon-circle-check {
    color: green;
    font-size: 20px;
  }

  i.classred {
    color: red !important;
    font-size: 20px;
    margin-left: 4px;
  }

  .addJd {
    margin-bottom: 14px;
    margin-top: -14px;
  }
}
</style>
